module.exports = __webpack_public_path__ + "static/media/ki.7182d9a7.png";